import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciChipsComponent } from './luci-chips.component';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [LuciChipsComponent],
  exports: [LuciChipsComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class LuciChipsModule { }
